import './AssessChoiceCard.scss'
import React, { PropTypes } from 'react'
import classnames from 'classnames'
import { Link } from 'react-router-dom'

const AssessChoiceCard = ({ to, title, prefix, desc, children, className}) => {
  return (
    <Link to={to} className={classnames('AssessChoice_card', className)}>
      <div className='AssessChoice_card_info'>
        <h4>{prefix}</h4>
        <h1>{title}</h1>
        <p>{desc}</p>
      </div>
      <div className='AssessChoice_card_action'>
        {children}
      </div>
    </Link>
  )
}

AssessChoiceCard.displayName = 'AssessChoiceCard'

AssessChoiceCard.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  title: PropTypes.string,
  desc: PropTypes.string
}

export default AssessChoiceCard



// WEBPACK FOOTER //
// ./src/assess/AssessChoiceCard.js